var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81989 1.308C7.28589 0.438 9.02189 0 10.9999 0C12.9519 0 14.6159 0.986 15.7639 1.666C16.7359 2.246 17.8239 3 18.9999 3C20.1759 3 21.2639 2.244 22.2359 1.666C23.3859 0.988 25.0499 0 26.9999 0C28.9799 0 30.7159 0.438 32.1799 1.308C33.6439 2.178 34.7259 3.416 35.4919 4.844C36.9919 7.636 37.3319 11.228 37.1259 14.724C36.9159 18.274 36.1259 21.986 35.1239 25.214C34.1279 28.416 32.8759 31.29 31.6639 33.11C30.2719 35.196 28.3379 36.234 26.2879 35.946C24.4059 35.682 22.9439 34.36 22.2119 32.894C21.4299 31.33 21.0679 29.584 20.3819 27.978C20.0406 27.1873 19.7172 26.624 19.4119 26.288C19.0919 25.936 18.8979 25.946 18.5899 26.288C18.2832 26.624 17.9592 27.1873 17.6179 27.978C16.9319 29.584 16.5719 31.33 15.7899 32.894C15.0559 34.36 13.5939 35.682 11.7139 35.946C9.66189 36.234 7.72789 35.196 6.33589 33.11C5.12389 31.29 3.87189 28.416 2.87589 25.214C1.87389 21.986 1.08389 18.274 0.875892 14.726C0.667892 11.226 1.00789 7.636 2.50789 4.844C3.27389 3.416 4.35589 2.178 5.81989 1.308Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDental);
export default __webpack_public_path__ + "static/media/dental.657bd07ee79716e8d291aafdb73dbe64.svg";
export { ForwardRef as ReactComponent };